export const REVIEW_ENGINE_COLUMNS = [
  'REVIEW_ACTION_STATUS',
  'REVIEW_LAST_UPDATE_DATE',
];
